import { render, staticRenderFns } from "./backend.vue?vue&type=template&id=764eb1e6&"
import script from "./backend.vue?vue&type=script&lang=js&"
export * from "./backend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('764eb1e6')) {
      api.createRecord('764eb1e6', component.options)
    } else {
      api.reload('764eb1e6', component.options)
    }
    module.hot.accept("./backend.vue?vue&type=template&id=764eb1e6&", function () {
      api.rerender('764eb1e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/static/backend.vue"
export default component.exports